import IPSViolationAdmin from "../components/rulesAndEnforcements/IPSViolationAdmin";

export const enforcementRoutes = [
  {
    path: "/RulesandEnforce/ips-violations-admin",
    component: IPSViolationAdmin
  }
];
